import { ProgramType } from "@/modules/programs/types/programTypes"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { z } from "zod"

/* TODO NST : Those are suppositions */
export const CoachProgrammationItemDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    image: HUImageDtoSchema.nullable(),
    creationDate: z.string(),
    type: z.enum(ProgramType),
  })
  .meta({ id: "CoachProgrammationItemDtoSchema" })

export const CoachProgrammationDetailsDtoSchema = CoachProgrammationItemDtoSchema.extend({}).meta({
  id: "CoachProgrammationDetailsDtoSchema",
})

export const CreateCoachProgrammationInputDtoSchema = z
  .object({
    name: z.string(),
    description: z.string().nullable(),
    imageKey: z.string().nullable(),
  })
  .meta({ id: "CreateCoachProgrammationInputDtoSchema" })

export const UpdateCoachProgrammationInputDtoSchema = z
  .object({
    name: z.string(),
    description: z.string().nullable(),
    imageKey: z.string().nullable(),
  })
  .meta({ id: "UpdateCoachProgrammationInputDtoSchema" })

export type CoachProgrammationItemDto = z.infer<typeof CoachProgrammationItemDtoSchema>
export type CoachProgrammationDetailsDto = z.infer<typeof CoachProgrammationDetailsDtoSchema>
export type CreateCoachProgrammationInputDto = z.infer<typeof CreateCoachProgrammationInputDtoSchema>
export type UpdateCoachProgrammationInputDto = z.infer<typeof UpdateCoachProgrammationInputDtoSchema>
